define('lq/services/application/applicationServiceFactory',[
    'lq/typesProvider',
    
    './applicationValidation',
    './issueTracking',
    './pullDownEvents',
    './runtimeAnnotations',
], function (TypesProvider) {
    'use strict';

    var servicesTypes = Array.prototype.slice.call(arguments, 1);
    var typesProvider = new TypesProvider(servicesTypes);

    var createService = function (service) {
        var ServiceType = typesProvider.get(service.serviceType);
        var instance = new ServiceType(service.data);
        return instance;
    };

    return {
        createService: createService
    };
});
